'use client';

// Re-export the provider and context hooks from the main react module
export {
  PreprToolbarProvider,
  usePreprToolbar,
} from '../../react/components/toolbar/toolbar-provider';

// Export the Pages-compatible PreprToolbar component
import React from 'react';
import { PreprToolbarProvider } from '../../react/components/toolbar/toolbar-provider';
import ToolbarWrapper from './components/toolbar/toolbar-wrapper';
import { SegmentProvider } from '../../react/contexts/segment-context';
import { VariantProvider } from '../../react/contexts/variant-context';
import { EditModeProvider } from '../../react/contexts/edit-mode-context';
import { PreprToolbarProps, PreprToolbarOptions } from '../../types';
import { StegaErrorBoundary } from '../../react/components/error-boundary';

interface PreprToolbarPropsPages extends PreprToolbarProps {
  hideBar?: boolean;
  options?: PreprToolbarOptions;
}

function PreprToolbar(props: PreprToolbarPropsPages) {
  const {
    data = [],
    activeSegment,
    activeVariant,
    hideBar = false,
    options,
  } = props;

  if (hideBar) {
    return null;
  }

  return (
    <StegaErrorBoundary>
      <PreprToolbarProvider
        props={{ data, activeSegment, activeVariant }}
        options={options}
      >
        <SegmentProvider initialSegments={data} activeSegment={activeSegment}>
          <VariantProvider activeVariant={activeVariant}>
            <EditModeProvider>
              <ToolbarWrapper />
            </EditModeProvider>
          </VariantProvider>
        </SegmentProvider>
      </PreprToolbarProvider>
    </StegaErrorBoundary>
  );
}

export default PreprToolbar;

// Re-export other non-navigation dependent components
export { default as PreprTrackingPixel } from '../../react/components/ui/prepr-tracking-pixel';

// Export the compatibility router hook for custom implementations
export { useCompatRouter } from './hooks/use-compat-router';
